<template>
    <div class="menu-container">
        <nav id="navbar" class="nav-bar" v-bind:class="[{'active': activated}, {'nav-bar--light': sectionThemeDark}, {' nav-bar--dark': !sectionThemeDark}]">
            <a href="#" @click.prevent="goBack">
                <div class="menu icon icon-back-button"></div>
            </a>
        </nav>
        <div id="socialIconsWeb" class="social-icons-web">
            <ul class="social-items" v-bind:class="[{'light': socialIconsWebThemeDark}, {'dark': !socialIconsWebThemeDark}]">
                <li>
                    <a href="https://www.facebook.com/GlobalChoicesZA/" class="facebook" target="_blank" rel="noopener noreferrer"></a>
                </li>
                <li>
                    <a href="https://twitter.com/GlobalChoicesZA" class="twitter" target="_blank" rel="noopener noreferrer"></a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/company/global-choices-lifestyle/?originalSubdomain=za" class="linkedin" target="_blank" rel="noopener noreferrer"></a>
                </li>
                <li>
                    <a href="https://www.instagram.com/globalchoicesza/" class="instagram" target="_blank" rel="noopener noreferrer"></a>
                </li>
                <li>
                    <a href="https://www.youtube.com/channel/UCbCW_LVHs3zhXqtY6yRETBQ" class="youtube" target="_blank" rel="noopener noreferrer"></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReturnMenu",
    props: [],
    data() {
        return {
            activated: false,
            menuClass: 'nav-bar--light',
            sectionThemeDark: true,
            backgroundColor: '#fff',
            scrolled: false,
            currentSectionID: 0,
            scrollBarPos: 0,
            scrollBarPosYoffset: 0,
            sectionHeight: 0,
            sectionEndPos: 0,
            appTheme: true,
            socialIconsWebThemeDark: true
        };
    },
    methods: {
        markActive() {
            this.activated = !this.activated;
        },
        handleScroll() {
            let scrolling = false;
            setInterval(function () {
                if (scrolling) {
                    scrolling = false;
                }
            }, 250);

            this.scrollBarPos = window.scrollY;

            let letCurrentSectionID = 0;
            let letNextSectionID = 0;
            let windowHeight = window.innerHeight;
            let iconTriggerPosition = windowHeight * 0.9;
            const sections = document.querySelectorAll('.section');
            this.scrollBarPosYoffset = window.pageYOffset;

            let index = 0, length = sections.length;
            for (index; index < length; index++) {
                let sectionStartPos = sections[index].offsetTop;
                if ((sectionStartPos - 30) <= this.scrollBarPos) {
                    this.currentSectionID = index;
                    letCurrentSectionID = index;
                }
                if ((sectionStartPos - iconTriggerPosition) <= this.scrollBarPos) {
                    letNextSectionID = index;
                }
            }
            this.setMenuClass(letCurrentSectionID, sections);
            this.setSocialIconClass(letNextSectionID, sections);
        },
        setMenuClass(sectionID, sections) {
            let ValSectionThemeDark = sections[sectionID].dataset.sectionthemedark;
            if (!ValSectionThemeDark) {
                this.sectionThemeDark = true;
            } else if (ValSectionThemeDark == 'true') {
                this.sectionThemeDark = true;
            } else {
                this.sectionThemeDark = false;
            }
        },
        setSocialIconClass(nextSectionID, sections) {
            let ValSocialIconsWebThemeDark = sections[nextSectionID].dataset.sectionthemedark;
            if (!ValSocialIconsWebThemeDark) {
                this.socialIconsWebThemeDark = true;
            } else if (ValSocialIconsWebThemeDark == 'true') {
                this.socialIconsWebThemeDark = true;
            } else {
                this.socialIconsWebThemeDark = false;
            }
        },
        goto(idName) {
            const navLocation = document.getElementById(idName);
            let top = navLocation.offsetTop;
            window.scrollTo(0, top);
        },
        goBack() {
            window.history.go(-1);
        }
    },
    created: function () {
        let scrolling = false;
        window.addEventListener('scroll', scrollActive);
        function scrollActive() {
            scrolling = true;
        }
        setInterval(() => {
            if (scrolling) {
                scrolling = false;
                this.handleScroll();
            }
        }, 350);
    }
};
</script>

<style lang="scss" scoped>
.appTheme {
    background-color: #575756;
    a {
        color: #ffffff;
    }
}
.companyTheme {
    background-color: #ffffff;
    a {
        color: #575756;
    }
}
</style>
